import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./changeAppointmentConfirmationPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png"; 

interface ConfirmationPopupProps {
    onConfirm: () => void;
    onCancel: () => void;
    userName: string;
}

function ConfirmationPopup({ onConfirm, onCancel,userName }: ConfirmationPopupProps) {
    return (
        <article className={popupStyles.popup}>
            <div className={popupStyles.popup__title_container}>
                <h2 className={popupStyles.popup__text}>
                 {t('THERE_IS_ALREADY_TREATMENT')}{userName} {t('SHOULD_I_KEEP_ANYWAY')}</h2>
                <img
                    src={doctor}
                    alt={t('ALTERNATIVE_APPOINTMENT_POPUP_IMAGE_ALT')}
                    className={popupStyles.popup__img}
                />
            </div>

            <div className={popupStyles.popup__nextBtn_container}>
                <button
                    className={`button hover ${popupStyles.popup__nextBtn}`}
                    onClick={onConfirm}
                >
                    {t('YES')}</button>
                <button
                    className={`button hover ${popupStyles.popup__nextBtn}`}
                    onClick={onCancel}
                >{t('TRANSFER_APPOINTMENT_NO')}</button>
            </div>
        </article>
    );
}

export default ConfirmationPopup;
